import { Box } from "@mui/material";
import { type FunctionComponent } from "react";
import { Handle, Position } from "reactflow";

interface OutputHandleProps {
  handleSize: number;
  handleHoverScale: number;
  handleColor: string;
  handleHoverColor: string;
  handleBorderColor: string;
}

const OutputHandle: FunctionComponent<OutputHandleProps> = ({
  handleSize,
  handleHoverScale,
  handleColor,
  handleHoverColor,
  handleBorderColor,
}) => {
  return (
    <Box
      sx={{
        "& .react-flow__handle": {
          transition:
            "transform 120ms ease-out, background-color 120ms ease-out",
        },
        "& .react-flow__handle:hover": {
          backgroundColor: `${handleHoverColor} !important`,
          // Keeps the dot centered on the node edge while it grows
          transform: `translateY(-50%) scale(${handleHoverScale})`,
        },
      }}
    >
      <Handle
        id="output"
        position={Position.Right}
        style={{
          background: handleColor,
          // The ring separates the dot from whatever is behind it, which is
          // the node body on one side and the canvas on the other
          border: `2px solid ${handleBorderColor}`,
          borderRadius: "50%",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
          // Centers the dot on the right border of the node
          top: "50%",
          right: -handleSize / 2,
          transform: "translateY(-50%)",
          width: handleSize,
          height: handleSize,
        }}
        type="source"
      />
    </Box>
  );
};

export default OutputHandle;
